import './main.css';
import { Elm } from './Main.elm';
import createVirtualAudioGraph from 'virtual-audio-graph'

import registerServiceWorker from './registerServiceWorker';

window.AudioContext = window.AudioContext || window.webkitAudioContext;
if (typeof window.AudioContext === 'undefined') {
  alert('Sorry, this browser does not support the Web Audio API.');
}

var app = Elm.Main.init({
  node: document.getElementById('root')
  , flags: { width: window.innerWidth,
             height: window.innerHeight
           }
});

app.ports.foundCachedState.send(JSON.parse(localStorage.getItem('cache')));

window.addEventListener("beforeunload", function(event) {
    app.ports.requestPersistInLocalStorage.send(null);
});

window.onblur = function () {
    app.ports.applicationLostFocus.send(null);
}

const audioContext = new AudioContext();
const virtualAudioGraph = createVirtualAudioGraph({
  audioContext: audioContext,
  output: audioContext.destination
});

app.ports.renderContextJs.subscribe(function(graph) {
  virtualAudioGraph.update(graph);
});

app.ports.persistInLocalStorage.subscribe(function(json){
//    console.log('setting "cache" key in localstorage', JSON.stringify(json))
    localStorage.setItem('cache', JSON.stringify(json));
});

registerServiceWorker();
